export default "/_next/static/images/PrivilegeDraft-ec1cf54b21118ca5b9758193534fb8e1.png";